import { RootPage } from "@components/home/RootPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_data/")({
  component: RootPage,
});
